export default __webpack_public_path__ + "static/media/basicRectangle.f7d6b450.svg";